// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1K0Hl","amount":"Amount_amount__cXWZC","tip":"Amount_tip__MHTOw","tipHeader":"Amount_tipHeader__1RTqO","tipsWrap":"Amount_tipsWrap__25AgO"};